
export enum DynamicFiltersModulesDescriptions {
  Alerts = 'Alerts',
  Cases = 'Cases',
  Complaint = 'Complaint'
}
